(function () {
  "use strict";
  if (window.PartifyPartsPaintCodeNames) {
    window.PartifyPartsPaintCodeNames.initialize();
    return;
  }
  const bound = new WeakSet();
  function post(payload) {
    const controller = new AbortController();
    const timeout = setTimeout(function () { controller.abort(); }, 8000);
    return fetch("https://auto-realm.myshopify.com/api/2024-01/graphql.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": "2bcf68ed45edc56c19f2f3aa226eb101",
      },
      body: JSON.stringify(payload), signal: controller.signal,
    }).then(function (response) {
      if (!response.ok) throw new Error("Paint names unavailable");
      return response.json();
    }).finally(function () { clearTimeout(timeout); });
  }
  function initialize() {
    const colors = window.PartifyTouchupColorDetails;
    if (!colors || !colors.loadNames) return;
    document.querySelectorAll("select[data-parts-paint-code-names]").forEach(function (select) {
      if (bound.has(select)) return;
      bound.add(select);
      const labels = new WeakMap();
      let details = null;
      let contextKey = "";
      let revision = 0;
      let scheduled = false;
      const controls = select.closest(".combined-variant-dropdown") || select.parentElement;
      const panel = controls.querySelector("[data-parts-paint-preview]");
      const photo = panel?.querySelector("[data-parts-paint-photo]");
      const status = panel?.querySelector("[data-parts-paint-status]");
      const enlarge = panel?.querySelector("[data-parts-paint-enlarge]");
      const dialog = controls.querySelector("[data-parts-paint-dialog]");
      let photoKey = "";
      let photoRevision = 0;
      let resettingPhoto = false;
      function vehicle() {
        try {
          const terms = typeof window.getSearchTerms === "function"
            ? window.getSearchTerms() : JSON.parse(localStorage.getItem("searchTerms") || "[]");
          return terms?.[0] || window.PartifyFitment?.getActiveVehicle?.() || null;
        } catch (_) { return null; }
      }
      function render() {
        Array.from(select.options).forEach(function (option) {
          const raw = String(option.dataset.variantTitle || "").split(" / ").pop().trim();
          if (!option.value || !raw || /^(?:unpainted|sin pintar|\.?vin)$/i.test(raw) || /match.*vin|custom paint/i.test(raw)) return;
          let saved = labels.get(option);
          if (!saved || option.textContent !== saved.rendered) {
            const text = option.textContent;
            const price = text.match(/\s+[+-](?=\$|\d)[\s\S]*$/);
            const title = (price ? text.slice(0, price.index) : text).split(" \u2014 ")[0];
            saved = {title: title, price: price ? price[0] : ""};
          }
          const name = colors.name(details, raw);
          saved.rendered = saved.title + (name ? " \u2014 " + name : "") + saved.price;
          labels.set(option, saved);
          if (option.textContent !== saved.rendered) option.textContent = saved.rendered;
        });
      }
      function selectedPhoto() {
        const request = window.PartifyPaintDecoderRequest;
        const option = select.selectedOptions[0];
        if (request?.status === "pending" || select.disabled || !option?.value || option.disabled ||
          option.dataset.unavailable === "true" || controls.querySelector("#checkbox-select-unpainted")?.checked) return null;
        const active = vehicle();
        if (!active || !colors.key(active)) return null;
        const manual = controls.querySelector("#checkbox-select-paint-option")?.checked;
        const stored = controls.querySelector("#checkbox-paint-code-local-storage")?.checked;
        if (!manual && (!stored || (request && request.status !== "resolved"))) return null;
        const code = String(manual ? option.dataset.variantTitle || "" : active.paintCode || active.troublesome_format || "")
          .split(" / ").pop().trim().toUpperCase();
        if (!code || /^(?:UNPAINTED|SIN PINTAR|\.?VIN)$/.test(code) || /MATCH.*VIN|CUSTOM PAINT/.test(code)) return null;
        return {vehicle: active, code: code, key: colors.key(active) + "|" + code};
      }
      function refreshPhoto() {
        if (!panel || !photo || !status || !enlarge || !dialog) return;
        const current = selectedPhoto();
        const nextKey = current?.key || "";
        if (nextKey === photoKey) return;
        photoKey = nextKey;
        const job = ++photoRevision;
        if (dialog.open) dialog.close();
        enlarge.disabled = true;
        resettingPhoto = true;
        colors.renderPreview(photo, null, "");
        resettingPhoto = false;
        panel.hidden = true;
        status.hidden = !current;
        status.textContent = current ? panel.dataset.previewLoading : "";
        if (!current) return;
        colors.load(current.vehicle, post, "CAD", current.code).then(function (result) {
          if (job !== photoRevision || selectedPhoto()?.key !== nextKey) return;
          if (!result?.images?.[current.code]) { panel.hidden = true; return; }
          colors.renderPreview(photo, result, current.code);
        }).catch(function () { if (job === photoRevision) panel.hidden = true; });
      }
      if (photo && panel && enlarge && dialog) {
        photo.addEventListener("partify:paint-preview:visibility", function () {
          if (resettingPhoto || selectedPhoto()?.key !== photoKey) return;
          panel.hidden = photo.hidden;
          status.hidden = true;
          enlarge.disabled = photo.hidden;
          if (photo.hidden) return;
          const caption = photo.querySelector("figcaption");
          const label = document.createElement("span");
          label.className = "parts-paint-preview__label";
          label.textContent = caption.textContent;
          const disclaimer = document.createElement("small");
          disclaimer.className = "parts-paint-preview__disclaimer";
          disclaimer.textContent = panel.dataset.previewDisclaimer;
          caption.replaceChildren(label, disclaimer);
        });
        enlarge.addEventListener("click", function () {
          if (photo.hidden || photo.hasAttribute("aria-busy") || selectedPhoto()?.key !== photoKey) return;
          const expanded = photo.cloneNode(true);
          expanded.removeAttribute("data-parts-paint-photo");
          dialog.querySelector("[data-parts-paint-dialog-photo]").replaceChildren(expanded);
          dialog.showModal();
        });
        dialog.querySelector("[data-parts-paint-close]").addEventListener("click", function () { dialog.close(); });
        dialog.addEventListener("click", function (event) {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        dialog.addEventListener("close", function () { dialog.querySelector("[data-parts-paint-dialog-photo]").replaceChildren(); });
      }
      function refresh() {
        scheduled = false;
        const active = vehicle();
        const nextKey = active ? colors.key(active) : "";
        if (contextKey !== nextKey) {
          contextKey = nextKey;
          details = null;
          const job = ++revision;
          if (nextKey) colors.loadNames(active, post, "CAD").then(function (result) {
            if (job !== revision || colors.key(vehicle()) !== nextKey) return;
            details = result;
            render();
          });
        }
        render();
        refreshPhoto();
      }
      function schedule() {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(refresh);
      }
      new MutationObserver(schedule).observe(select, {
        childList: true, subtree: true, characterData: true, attributes: true,
        attributeFilter: ["data-variant-title", "disabled"],
      });
      controls.addEventListener("change", schedule);
      controls.addEventListener("click", schedule);
      for (const event of ["searchTermsUpdated", "partify:vehicle:changed", "partify:paint-selection:changed", "pageshow", "storage"]) window.addEventListener(event, schedule);
      document.addEventListener("variantsUpdated", schedule);
      refresh();
    });
  }
  window.PartifyPartsPaintCodeNames = {initialize: initialize};
  document.addEventListener("shopify:section:load", initialize);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initialize, {once: true});
  else initialize();
})();
